// extracted by mini-css-extract-plugin
var _1 = "PKcjaypCw5";
export { _1 as "loadingProgress" }
